module.exports = [
  'area',
  'base',
  'basefont',
  'dialog',
  'datalist',
  'head',
  'link',
  'meta',
  'noembed',
  'noframes',
  'param',
  'rp',
  'script',
  'source',
  'style',
  'template',
  'track',
  'title'
]



//////////////////
// WEBPACK FOOTER
// ./node_modules/rehype-minify-whitespace/skippable.js
// module id = JtEa
// module chunks = 0